// frontend/src/pages/Login.js

import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Image,
  Button,
  Navbar,
  Form,
  Nav,
  Alert,
  Modal
} from "react-bootstrap";
import { AuthService } from "../services";
import { Wave, Portfolio, Logo, Avatar } from "../img";
import "./Login.css";

export default class Login extends Component {
  constructor(props) {
    super(props);

    this.handleLogin = this.handleLogin.bind(this);
    this.handleAdminLogin = this.handleAdminLogin.bind(this);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.onChangeAdminUsername = this.onChangeAdminUsername.bind(this);
    this.onChangeAdminPassword = this.onChangeAdminPassword.bind(this);
    this.handleShowAdminModal = this.handleShowAdminModal.bind(this);
    this.handleCloseAdminModal = this.handleCloseAdminModal.bind(this);
    this.toggleDotsMenu = this.toggleDotsMenu.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);

    this.state = {
      username: "",
      password: "",
      adminUsername: "",
      adminPassword: "",
      loading: false,
      adminLoading: false,
      message: "",
      adminMessage: "",
      userInvalid: false,
      pwInvalid: false,
      currentUser: AuthService.getCurrentUser(),
      showAdminModal: false,
      showDotsMenu: false,
    };
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
  }

  handleOutsideClick(e) {
    if (this.dotsMenuRef && !this.dotsMenuRef.contains(e.target)) {
      this.setState({ showDotsMenu: false });
    }
  }

  toggleDotsMenu() {
    this.setState((prev) => ({ showDotsMenu: !prev.showDotsMenu }));
  }

  onChangeUsername(e) {
    this.setState({ message: "", username: e.target.value, userInvalid: false });
  }

  onChangePassword(e) {
    this.setState({ message: "", password: e.target.value, pwInvalid: false });
  }

  onChangeAdminUsername(e) {
    this.setState({ adminMessage: "", adminUsername: e.target.value });
  }

  onChangeAdminPassword(e) {
    this.setState({ adminMessage: "", adminPassword: e.target.value });
  }

  handleShowAdminModal() {
    this.setState({ showAdminModal: true, showDotsMenu: false, adminMessage: "" });
  }

  handleCloseAdminModal() {
    this.setState({
      showAdminModal: false,
      adminUsername: "",
      adminPassword: "",
      adminMessage: "",
    });
  }

  handleLogin(e) {
    e.preventDefault();
    localStorage.clear();
    sessionStorage.clear();

    this.setState({ loading: true, message: "" });

    if (this.state.username === "" || this.state.password === "") {
      this.setState({
        userInvalid: !this.state.username,
        pwInvalid: !this.state.password,
        loading: false,
      });
      return;
    }

    AuthService.login(
      this.state.username,
      this.state.password
    ).then(
      (response) => {
        const currentUser = AuthService.getCurrentUser();
        if (currentUser && currentUser.username === this.state.username) {
          this.props.history.push("/dashboard");
          window.location.reload();
        } else {
          this.setState({ loading: false, message: "Login failed - storage error" });
        }
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        this.setState({
          userInvalid: true,
          pwInvalid: true,
          loading: false,
          message: resMessage,
        });
      }
    );
  }

  handleAdminLogin(e) {
    e.preventDefault();

    this.setState({ adminLoading: true, adminMessage: "" });

    if (this.state.adminUsername === "" || this.state.adminPassword === "") {
      this.setState({
        adminLoading: false,
        adminMessage: "Please enter both username and password",
      });
      return;
    }

    AuthService.adminLogin(this.state.adminUsername, this.state.adminPassword)
      .then((data) => {
        const currentUser = AuthService.getCurrentUser();
        if (currentUser && currentUser.username === this.state.adminUsername) {
          this.setState({ adminLoading: false, showAdminModal: false });
          this.props.history.push("/admin/dashboard");
          window.location.reload();
        } else {
          this.setState({
            adminLoading: false,
            adminMessage: "Admin login failed - storage error",
          });
        }
      })
      .catch((error) => {
        this.setState({
          adminLoading: false,
          adminMessage: error.message || "Admin login failed.",
        });
      });
  }

  render() {
    const { currentUser, showDotsMenu } = this.state;

    if (currentUser != null) {
      this.props.history.push("/dashboard");
      window.location.reload();
    }

    return (
      <Container fluid className="login-container">
        <Image src={Wave} className="wave-background position-fixed h-100" />

        {/* ── Three-dot menu (fixed top-right, visible on all screen sizes) ── */}
        <div
          ref={(ref) => (this.dotsMenuRef = ref)}
          style={{
            position: "fixed",
            top: "14px",
            right: "16px",
            zIndex: 9999,
          }}
        >
          {/* Dots button */}
          <button
            onClick={this.toggleDotsMenu}
            aria-label="More options"
            style={{
              background: "rgba(255,255,255,0.18)",
              border: "1px solid rgba(255,255,255,0.35)",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "4px",
              padding: "0",
              backdropFilter: "blur(4px)",
              boxShadow: "0 2px 8px rgba(0,0,0,0.18)",
            }}
          >
            <span
              style={{
                width: "5px",
                height: "5px",
                borderRadius: "50%",
                backgroundColor: "#fff",
                display: "block",
              }}
            />
            <span
              style={{
                width: "5px",
                height: "5px",
                borderRadius: "50%",
                backgroundColor: "#fff",
                display: "block",
              }}
            />
            <span
              style={{
                width: "5px",
                height: "5px",
                borderRadius: "50%",
                backgroundColor: "#fff",
                display: "block",
              }}
            />
          </button>

          {/* Dropdown menu */}
          {showDotsMenu && (
            <div
              style={{
                position: "absolute",
                top: "48px",
                right: "0",
                backgroundColor: "#fff",
                borderRadius: "10px",
                boxShadow: "0 4px 24px rgba(0,0,0,0.18)",
                minWidth: "200px",
                overflow: "hidden",
                border: "1px solid #e8e8e8",
              }}
            >
              <button
                onClick={this.handleShowAdminModal}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  width: "100%",
                  padding: "13px 18px",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "14px",
                  color: "#333",
                  textAlign: "left",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#f0f4ff")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
              >
                <span style={{ fontSize: "17px" }}>🔐</span>
                Login as Administrator
              </button>
            </div>
          )}
        </div>

        {/* Navbar */}
        <Navbar className="login-navbar">
          <Navbar.Brand href="./" className="login-brand">
            <img src={Logo} alt="Super Coin" className="logo-img" />
          </Navbar.Brand>
        </Navbar>

        <Row className="main-content align-items-center">
          {/* Left column – hidden on mobile */}
          <Col lg={6} md={6} className="left-col d-none d-md-flex">
            <div className="left-content">
              <div className="logo-display text-center mb-4">
                <img src={Logo} alt="Super Coin" className="large-logo" />
                <h1 className="brand-title">Super Coin</h1>
                <p className="brand-tagline">Secure Digital Trading Platform</p>
              </div>
              <Image
                src={Portfolio}
                className="mx-auto my-auto portfolio-image"
                fluid
              />
            </div>
          </Col>

          {/* Right column – login form */}
          <Col lg={6} md={6} xs={12} className="right-col">
            <div className="login-form-container mx-auto">
              <div className="form-header text-center mb-4">
                <div className="form-logo-container">
                  <img src={Logo} alt="Super Coin" className="form-logo" />
                </div>
                <h1 className="text-dark login-title">Welcome</h1>
                <p className="text-muted login-subtitle">
                  Sign in to your account
                </p>
              </div>

              <Form className="text-center" onSubmit={this.handleLogin}>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Username"
                    onChange={this.onChangeUsername}
                    isInvalid={this.state.userInvalid}
                    className="login-input"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Control
                    type="password"
                    placeholder="Password"
                    onChange={this.onChangePassword}
                    isInvalid={this.state.pwInvalid}
                    className="login-input"
                  />
                </Form.Group>

                <Alert
                  variant="danger"
                  show={!!this.state.message}
                  className="alert-message"
                >
                  {this.state.message}
                </Alert>

                <Button
                  variant="primary"
                  type="submit"
                  className="w-100 mb-3 login-btn"
                  disabled={this.state.loading}
                >
                  {this.state.loading ? "Logging in..." : "Login"}
                </Button>

                <Nav className="justify-content-center register-link-container">
                  <Nav.Item>
                    <Nav.Link href="./register" className="register-link">
                      Request Access
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Form>
            </div>
          </Col>
        </Row>

        {/* Admin Login Modal */}
        <Modal
          show={this.state.showAdminModal}
          onHide={this.handleCloseAdminModal}
          centered
          className="admin-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Admin Login</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={this.handleAdminLogin}>
              <Form.Group className="mb-3">
                <Form.Label>Admin Username</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter admin username"
                  value={this.state.adminUsername}
                  onChange={this.onChangeAdminUsername}
                  required
                  className="admin-input"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Admin Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter admin password"
                  value={this.state.adminPassword}
                  onChange={this.onChangeAdminPassword}
                  required
                  className="admin-input"
                />
              </Form.Group>

              <Alert
                variant="danger"
                show={!!this.state.adminMessage}
                className="admin-alert"
              >
                {this.state.adminMessage}
              </Alert>

              <Button
                variant="primary"
                type="submit"
                className="w-100 admin-submit-btn"
                disabled={this.state.adminLoading}
              >
                {this.state.adminLoading ? "Logging in..." : "Login as Admin"}
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
      </Container>
    );
  }
}
